import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, List, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";

const PlanWithGCMLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionPlans = () => {
    return (
      <>      
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
                <Segment raised className={styles.segmentWhiteBGNoPadding} >  
                    <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
                    <>
                        <List.Item header="Are they licensed?"  />
                        <List.Item header="How long have they been providing care management services?" />
                        <List.Item header="Are they available for emergencies around the clock?" />
                        <List.Item header="Does the company also provide home care services?" />
                        <List.Item header="How does the communication between the care manager and patient/family work?" />
                        <List.Item header="How much does it cost? Are there different plan levels?" />
                        <List.Item header="Are they able to provide references?" style={{bottomBorder: "none"}}/>
                    </>
                    </List>
                </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Things to Look for in a Geriatric Care Manager: </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}GeriatricCareLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} exclusive={false}
                    className={styles.learnMoreModalAccordionGroup}
                    defaultActiveIndex={activeAccordionIndexes} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(PlanWithGCMLearnMore);
